import type { FragmentType } from 'src/gql';
import type { Deprecated_HandleItemUpdate } from 'src/types/account';
import { useState } from 'react';
import { UpdateType } from 'src/constants/portfolio';
import { graphql, unmaskFragment } from 'src/gql';

import { useMutationWithErrorLogging } from '@savvy/graphql-hooks/useMutationWithErrorLogging';

import { NetWorthItemMenu } from './views/net-worth-item-menu';

export const NetWorthLiabilityMenuFragment = graphql(/* GraphQL */ `
  fragment NetWorthLiabilityMenu on Liability {
    id
    hiddenFromClient
    hiddenFromNetWorth
  }
`);

const UPDATE_LIABILITY = graphql(/* GraphQL */ `
  mutation UpdateLiabilityFromNetWorthAccountItemMenu($input: UpdateLiabilityInput!) {
    updateLiability(input: $input) {
      liability {
        id
      }
    }
  }
`);

export function NetWorthLiabilityMenu({
  advisorView,
  liabilityFrag,
  onEdit,
}: {
  readonly advisorView?: boolean;
  readonly liabilityFrag: FragmentType<typeof NetWorthLiabilityMenuFragment>;
  readonly onEdit: Deprecated_HandleItemUpdate;
}) {
  const liability = unmaskFragment(NetWorthLiabilityMenuFragment, liabilityFrag);
  const [updateLiability] = useMutationWithErrorLogging(UPDATE_LIABILITY);
  const [hiddenFromNetWorth, setHiddenFromNetWorth] = useState(!!liability.hiddenFromNetWorth);
  const [hiddenFromClient, setHiddenFromClient] = useState(!!liability.hiddenFromClient);

  async function handleChange(field: 'hiddenFromNetWorth' | 'hiddenFromClient', value: boolean) {
    const updateType = UpdateType.SHOW_HIDE_NET_WORTH;

    await updateLiability({
      variables: {
        input: {
          id: liability.id,
          [field]: !value,
        },
      },
    });

    await onEdit({
      type: updateType,
      id: liability.id,
    });
  }

  return (
    <NetWorthItemMenu
      advisorView={advisorView}
      hiddenFromClient={hiddenFromClient}
      hiddenFromNetWorth={hiddenFromNetWorth}
      isManagedAccount={false}
      handleChange={handleChange}
      setHiddenFromClient={setHiddenFromClient}
      setHiddenFromNetWorth={setHiddenFromNetWorth}
    />
  );
}
